module.exports = __webpack_public_path__ + "static/pic01@2x-a5e45c2967b919095ecf1b088a9b4aaf.jpg";